module.exports = __webpack_public_path__ + "img/main_image4.37b1b522.png";